// This file was automatically generated from app.data.checklistTemplates.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.data.checklistTemplates');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.data.checklistTemplates.templateAsText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.template.type)? soy.$$escapeHtml(opt_data.template.type).toUpperCase() : '', ':\n');
  var fieldList6807 = opt_data.template.fields;
  var fieldListLen6807 = fieldList6807.length;
  for (var fieldIndex6807 = 0; fieldIndex6807 < fieldListLen6807; fieldIndex6807++) {
    var fieldData6807 = fieldList6807[fieldIndex6807];
    output.append(soy.$$escapeHtml(fieldData6807.name), ': ', soy.$$escapeHtml(fieldData6807.value), '\n');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.data.checklistTemplates.templateSingleLine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var fieldList6814 = opt_data.template.fields;
  var fieldListLen6814 = fieldList6814.length;
  for (var fieldIndex6814 = 0; fieldIndex6814 < fieldListLen6814; fieldIndex6814++) {
    var fieldData6814 = fieldList6814[fieldIndex6814];
    output.append(soy.$$escapeHtml(fieldData6814.name), ': ', soy.$$escapeHtml(fieldData6814.value), (! (fieldIndex6814 == fieldListLen6814 - 1)) ? '; ' : '');
  }
  if (!opt_sb) return output.toString();
};
